// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__kiNOx","active":"Link_active__kbl9E"};